import React, { Component, useEffect, useState } from 'react';

import ReactPaginate from 'react-paginate';
import './EventListPagination.css';

export default function EventListPagination(props) {
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })

  useEffect(() => {
    function handleResize() {
      if ((dimensions.width < 1100 && window.innerWidth > 1100) ||
        (dimensions.width > 1100 && window.innerWidth < 1100)) {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        })
      }
    }
    window.addEventListener('resize', handleResize)
    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <ReactPaginate
      previousLabel={' ← '}
      nextLabel={' → '}
      breakLabel={'...'}
      breakClassName={'break-me'}
      pageCount={props.pagination.total_pages || 0}
      marginPagesDisplayed={dimensions.width < 1100 ? 1 : 3}
      pageRangeDisplayed={dimensions.width < 1100 ? 1 : 3}
      initialPage={props.pagination.current_page - 1}
      onPageChange={props.handlePageClick}
      containerClassName={'pagination'}
      subContainerClassName={'pages pagination'}
      activeClassName={'active'}
    />
  )

}